export default "https://assets.pclncdn.com/web/next-landing/6889411/_next/static/images/pcln-hp-hero-hotels-d1805b4b49ed5da5acb0c48fcb0c0324.webp";